export default "__VITE_ASSET__CPJV8MWo__"